/** Prefer API `message`, then Error.message, then fallback. */
export function apiErrorMessage(error: unknown, fallback = 'Something went wrong'): string {
  const anyErr = error as { response?: { data?: { message?: unknown } }; message?: unknown };
  const api = anyErr?.response?.data?.message;
  if (api != null && String(api).trim()) return String(api);
  if (error instanceof Error && error.message.trim()) return error.message;
  if (typeof anyErr?.message === 'string' && anyErr.message.trim()) return anyErr.message;
  return fallback;
}
